import React from 'react';
import styled from 'styled-components';
import Tooltip from '@mui/material/Tooltip';
import { Icon } from './shell';

/**
 * Lucide info icon beside a field label. Explains what the field means on hover/focus.
 * Matches the dashboard KPI help affordance — presentation only.
 */
const HelpBtn = styled.button`
  display: inline-flex;
  align-items: center;
  margin-left: 5px;
  padding: 0;
  border: none;
  background: none;
  color: ${({ theme }) => theme.textSubtle};
  cursor: help;
  flex: none;
  vertical-align: middle;
  line-height: 0;

  &:hover,
  &:focus-visible {
    color: ${({ theme }) => theme.accentStrong};
    outline: none;
  }
`;

export default function FieldHelp({ text }) {
  if (!text) return null;

  return (
    <Tooltip title={text} arrow placement="top" enterTouchDelay={0}>
      <HelpBtn type="button" aria-label="What does this mean?">
        <Icon name="info" size={13} />
      </HelpBtn>
    </Tooltip>
  );
}

/** Inline label text with an optional help affordance. */
export function LabelWithHelp({ children, help }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
      {children}
      <FieldHelp text={help} />
    </span>
  );
}
